var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vks-ge-table research-data-table-wrapper" },
    [
      _vm.rows.length
        ? [
            _c("VariantSifterTableSettings", {
              attrs: {
                "per-page": Number(_vm.perPageNumber),
                columns: _vm.tableColumns,
                "visible-columns": _vm.visibleColumns,
              },
              on: {
                "update:perPage": _vm.onPerPageUpdate,
                "export-csv": _vm.exportCsv,
                "export-json": _vm.exportJson,
                "update:columnVisible": _vm.onColumnVisibleUpdate,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "before",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "vks-data-table-view-total" },
                          [
                            _vm._v(
                              " Total rows: " +
                                _vm._s(
                                  _vm.displayRows.length.toLocaleString()
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                1093982933
              ),
            }),
            _c(
              "div",
              { staticClass: "vks-ge-table-block" },
              [
                _c("div", { staticClass: "vks-ge-table-wrap" }, [
                  _c(
                    "table",
                    {
                      staticClass:
                        "table table-sm research-data-table vks-ge-data-table",
                      attrs: { cellpadding: "0", cellspacing: "0" },
                    },
                    [
                      _c("thead", [
                        _c(
                          "tr",
                          _vm._l(_vm.visibleTableColumns, function (column) {
                            return _c(
                              "th",
                              {
                                key: column,
                                staticClass: "byor-tooltip sortable-th",
                                class: _vm.getColumnId(column),
                                on: {
                                  click: function ($event) {
                                    return _vm.applySorting(column)
                                  },
                                },
                              },
                              [_c("span", [_vm._v(_vm._s(column))])]
                            )
                          }),
                          0
                        ),
                      ]),
                      _c(
                        "tbody",
                        _vm._l(_vm.pagedRows, function (row) {
                          return _c(
                            "tr",
                            { key: row.tissue },
                            _vm._l(_vm.visibleTableColumns, function (column) {
                              return _c(
                                "td",
                                {
                                  key: `${row.tissue}-${column}`,
                                  class: _vm.getColumnId(column),
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.formatCell(row, column)) +
                                      " "
                                  ),
                                ]
                              )
                            }),
                            0
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                ]),
                _vm.perPageNumber !== "0" && _vm.perPageNumber !== 0
                  ? _c("b-pagination", {
                      staticClass:
                        "pagination-sm justify-content-center vks-ge-pagination",
                      attrs: {
                        "total-rows": _vm.displayRows.length,
                        "per-page": Number(_vm.perPageNumber),
                      },
                      model: {
                        value: _vm.currentPage,
                        callback: function ($$v) {
                          _vm.currentPage = $$v
                        },
                        expression: "currentPage",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _c("div", { staticClass: "vks-ge-table-empty" }, [
            _vm._v(
              " No enrichment statistics for the current annotation and tissue filters. "
            ),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }